import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { batchService, studentService, staffService } from '../services/api';
import { useApp } from '../context/AppContext';

const AdminDashboard = () => {
  const { currentUser, notify } = useApp();
  const [batches, setBatches] = useState([]);
  const [staff, setStaff] = useState([]);
  const [students, setStudents] = useState([]);

  useEffect(() => {
    batchService.list().then(setBatches).catch((err) => notify(err.message, 'error'));
    staffService.list().then(setStaff).catch((err) => notify(err.message, 'error'));
    studentService.list().then(setStudents).catch((err) => notify(err.message, 'error'));
  }, [notify]);

  const unassigned = batches.filter((b) => !b.teacherId).length;

  return (
    <div className="page">
      <h1>Welcome, {currentUser.name}</h1>

      <div className="stats-grid">
        <div className="card stat-card">
          <h2>Batches</h2>
          <p className="stat">{batches.length}</p>
          {unassigned > 0 && <p className="stat-note">{unassigned} awaiting a teacher</p>}
          <Link to="/batches" className="btn-primary">Manage Batches</Link>
        </div>
        <div className="card stat-card">
          <h2>Staff</h2>
          <p className="stat">{staff.length}</p>
          <Link to="/staff" className="btn-primary">Manage Staff</Link>
        </div>
        <div className="card stat-card">
          <h2>Students</h2>
          <p className="stat">{students.length}</p>
          <Link to="/students" className="btn-primary">View Students</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
